import axiosInstance from "../../lib/axiosInstance";

export const generateDeviceCommand = async () => {
  try {
    const response = await axiosInstance.post(
      "/generate_command"
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.detail || "Failed to generate command"
    );
  }
};

export const listDevices = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/list_user_devices", { params });
    return {
      devices: response.data?.devices ?? [],
      count: response.data?.count ?? 0,
    };
  } catch (error) {
    throw new Error(
      error?.response?.data?.detail || "Failed to list devices"
    );
  }
};

